import React, { useEffect, useState } from 'react';
// import 'antd/dist/antd.css';
import { Table, Radio, message, Spin, Modal, Button, Row, Col, Card } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import efn from './BankFns'
import langObj from '../TopUserLang'
import './Bank.scss';
import DraggableTable from './DraggableTable'

function Bank(props) {
  const navigate = useNavigate()
  const location = useLocation()
  const [banks, setBanks] = useState([])
  const [isPageLoading, setIsPageLoading] = useState(true)
  const [isTableLoading, setIsTableLoading] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [modalTitle, setModalTitle] = useState("")
  const [modalContent, setModalContent] = useState()
  const [banksSortChange, setBanksSortChange] = useState([])
  const [isButtonSortLoading, setIsButtonSortLoading] = useState(false)
  const setFuncMap = {
    setBanks, setIsPageLoading, setIsModalOpen,
    setIsTableLoading, setModalTitle, setModalContent,
    setBanksSortChange,
    message, setIsButtonSortLoading
  }
  const moveColumns = efn.generateBankMoveMenu(props, setFuncMap)
  useEffect(() => {

    efn.getBanks(props, setFuncMap)
    efn.getConference(props, setFuncMap)

  }, []);
  
  return (
    <Spin spinning={isPageLoading}>
      <div className="Bank">
        <Row gutter={16} justify="end">
          {banksSortChange.length > 0 && <Col>
            <Button type="primary" loading={isButtonSortLoading}
              onClick={() => { efn.updateBanksSort(banksSortChange, props, setFuncMap) }}>更新排序</Button>
          </Col>}
          <Col>
            <Button type="primary" onClick={() => { efn.openBankCreatePage(props.conferenceUid, "建立銀行", setFuncMap) }}>建立銀行</Button>
          </Col>
        </Row>
        <Spin spinning={isTableLoading}>          
          <DraggableTable dataSource={banks}
            columns={moveColumns}
            setFuncMap={setFuncMap}/>

        </Spin>
        <Modal wrapClassName="modal-theme" width="80%" title={modalTitle} open={isModalOpen} footer={[]} destroyOnClose
          onCancel={() => { setIsModalOpen(false) }}>
          {modalContent}
        </Modal>
      </div>
    </Spin>
  );
}



export default Bank;
